import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { CreateOrderPage } from '../pages/create/CreateOrderPage';
import { ClientFeesTab } from '../components/clientPortal/clientFees/ClientFeesTab';
import { ClientTitleTab } from 'pages/clientPortal/ClientTitleTab';
import { ClientOrderOverviewContainer } from '../pages/clientPortal/orderOverview/ClientOrderOverviewContainer';
import { useRouteMatch } from 'react-router';

export const ClientOrderRouter: React.FC = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/create`} exact component={CreateOrderPage} />
      <Route path={`${path}/:orderId/title`} exact component={ClientTitleTab} />
      <Route path={`${path}/:orderId/fees`} exact component={ClientFeesTab} />
      <Route path={`${path}/:orderId/overview`} component={ClientOrderOverviewContainer} />
    </Switch>
  );
};
